import React, { useContext, useState } from 'react';
import useLocalStorage from './useLocalStorage';
import useWindowDimensions from './useWindowDimensions';

const DrawerContext = React.createContext<{
  isMobileMode: boolean;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  menuType: MenuType;
  setMenuType: (menuType: MenuType) => void;
  toggleDrawer: () => void;
}>(undefined!);

export type MenuType = 'condensed' | 'fixed';

const useDrawer = () => {
  const [menuType, setMenuType] = useLocalStorage<MenuType>('menuType', 'condensed');
  const { width } = useWindowDimensions();

  const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = () => setIsOpen((open) => !open);
  const isMobileMode = width < 1280;

  return { isOpen, setIsOpen, menuType, isMobileMode, setMenuType, toggleDrawer };
};

export const DrawerProvider = ({ children }) => {
  const value = useDrawer();

  return <DrawerContext.Provider value={value}>{children}</DrawerContext.Provider>;
};

export default () => useContext(DrawerContext);
